// Note: Consolidating tech-debt until clear theme upstream interface
// is decided for tertiary and secondary colors.
// JIRA: https://montugroup.atlassian.net/browse/UMED-7690

export const outOfBandThemeColors = {
  alternaleaf: {
    skyBlue: '#CEEDFF',
    teal: '#194457',
    darkTeal: '#455A64',
    deepRed: '#C53B00',
    lightPurple: '#498CCE',
    pastelYellow: '#F3EEE1',
    deepPink: '#FFC8B9',
    lightBlue: '#2085CB',
    grassGreen: '#008000',
    lightGray: '#CFD2D9',
    faintPurple: '#E9CFE9',
    lightGreen: '#B5F3D1',
    redOrange: '#FFC8B9',
    statusGray: '#E7E7E7',
    deepNavy: '#181B25',
  },
  uMeds: {
    warmWhite: '#FFFCF2',
    merino: '#F2EFE4',
    merino100: '#FBFAF7', // only adding new outOfBandThemeColors to get the preonboarding reskin over the line - will be dealt with in ticket listed above.
    merino300: '#F6F4EC',
    merinoDark: '#E8E4D1',
    timberGreen50: '#EBEEEF',
    timberGreen100: '#B4BFC3',
    secondary: {
      states: {
        active: 'rgba(255, 152, 69, 0.56)',
      },
    },
    infoA100: '#D3DDFF',
    accordionHeaderColors: {
      background: '#F6F4EC',
      borderTopColor: '#e8e4d1',
    },
    neutralColors: {
      divider: '#E8E4D1',
    },
    sunshade200: '#FFCCA2',
    divider: '#DEDEE1',
  },
  montu: {
    accordionHeaderColors: {
      background: '#E8E4D1',
      borderTopColor: '#E8E4D1',
    },
  },
};
